import { type DefaultProps, Logo } from '@egw/components'
import { type FC } from 'react'
import cx from 'classnames'
import { twMerge } from 'tailwind-merge'

interface ChatLogoProps extends DefaultProps {
  containerClassName?: string
}

export const ChatLogo: FC<ChatLogoProps> = ({ className, id, testId, ariaLabel, containerClassName }) => {
  const containerFinalClasses = twMerge(
    cx('size-6 shrink-0 rounded-[3px] bg-black flex justify-center items-center', containerClassName),
  )
  const logoFinalClasses = twMerge('w-4 h-4 fill-white', className)

  return (
    <div
      className={containerFinalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <Logo className={logoFinalClasses} />
    </div>
  )
}
